import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../core/config.service';
import { Injectable } from '@angular/core';

interface AlertDetails {
  description: string,
  location_id: string,
  location_name: string,
  room_id: string,
  room_name: string,
  stream_id: string,
  device_name: string,
  create_time: number,
  status: string
}

interface Alert {
  id: string,
  location_id: string,
  location_name: string,
  room_name: string,
  device_name: string,
  description: string,
  create_time: number,
  details: AlertDetails,
  status: string
}

@Injectable()
export class NotificationsService {

  constructor(private configService: ConfigService,
              private httpClient: HttpClient) {
  }

  getAllNotifications() {
    // Always fetch alerts as they are subject to change
    const url = this.configService.getNotifcationUrl() + '/alerts/list';
    return this.httpClient.get<Alert[]>(url).toPromise();
  }

  updateNotification(alert: Alert) {
    const url = this.configService.getNotifcationUrl() + '/alerts/' + alert.id;
    return this.httpClient.put<Alert>(url, alert).toPromise();
  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/notifications/notifications.service.ts